import { useEffect, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Smartphone } from "lucide-react";
import { LogoMark } from "./Logo";
import { useBrand } from "../../context/brand";
import { desktopGateNeeded, dismissDesktopGate } from "../../lib/source";
import { logAction } from "../../lib/chat";

const phoneUrl = () => {
  const u = new URL(window.location.href);
  u.searchParams.delete("lc");
  u.hash = "";
  return u.href;
};

export const DesktopGate = ({ children }) => {
  const brand = useBrand();
  const [gate, setGate] = useState(desktopGateNeeded);
  useEffect(() => { if (gate) logAction("view"); }, [gate]);
  if (!gate) return children;
  const goOn = () => { dismissDesktopGate(); setGate(false); };

  return (
    <div className="dg-page" data-testid="desktop-gate">
      <div className="dg-card">
        <LogoMark size={64} />
        <p className="dg-kicker"><Smartphone size={15} /> {brand?.name}</p>
        <h1 className="dg-title">Este atendimento é feito pelo celular</h1>
        <p className="dg-text">Aponte a câmera do seu celular para o código abaixo e continue a conversa por lá.</p>
        <div className="dg-qr" data-testid="desktop-gate-qr">
          <QRCodeSVG value={phoneUrl()} size={196} level="M" marginSize={2} />
        </div>
        <button type="button" className="dg-skip" data-testid="desktop-gate-continue" onClick={goOn}>continuar mesmo assim</button>
      </div>
    </div>
  );
};
